import { fetchJSON } from "../framework/api";
import * as Popup from "../framework/components/popup";
import { startPollingAsyncJob } from "../utils/async_job";

document.addEventListener("DOMContentLoaded", function () {
  for (const publicationElt of document.querySelectorAll(".skills-publication")) {
    const sessionId = publicationElt.dataset.sessionId;
    const customerId = publicationElt.dataset.customerId;

    const stateElt = publicationElt.querySelector(".skills-publication__state");

    const button = publicationElt.querySelector(".skills-publication__button");

    if (publicationElt.dataset.asyncJobHash) {
      // a job is still running, we need to poll current state
      pollState(publicationElt.dataset.asyncJobHash, button, stateElt);
    } else {
      showElement(button, true);
    }

    const confirmPopupElt = publicationElt.querySelector(".skills-publication-confirm__dialog");
    const formElt = publicationElt.querySelector("form.skills-publication-form");
    formElt.addEventListener("submit", async function (e) {
      e.preventDefault();

      Popup.close(confirmPopupElt);

      showElement(button, false);
      showElement(stateElt, true);
      stateElt.textContent = stateElt.dataset.running;
      const asyncJobHash = await startSessionCustomerPublicationToSkills(sessionId, customerId);
      pollState(asyncJobHash, button, stateElt);

      return false;
    });

    button.addEventListener("click", async function (e) {
      e.preventDefault();

      showElement(button, false);
      stateElt.textContent = stateElt.dataset.checking;
      showElement(stateElt, true);

      const checkResult = await checkPublishableSessionCustomerToSkills(sessionId, customerId);
      if (checkResult.error) {
        const errorPopupElt = publicationElt.querySelector(".skills-publication-error__dialog");
        Popup.open(errorPopupElt);

        showElement(stateElt, false);
        showElement(button, true);
      } else {
        Popup.open(confirmPopupElt);

        showElement(stateElt, false);
        showElement(button, true);
      }

      return false;
    });
  }
});

function pollState(asyncJobHash, button, stateElt) {
  startPollingAsyncJob(asyncJobHash, (res) => {
    if (res && !res.stopped) {
      showElement(button, false);
      stateElt.textContent = `${stateElt.dataset.prefix}: ${res.state_str}`;
      showElement(stateElt, true);
      return true;
    } else {
      // no job found or stopped
      window.location.reload();
      return false;
    }
  });
}

function showElement(element, show) {
  element.classList.toggle("hidden", !show);
}

async function checkPublishableSessionCustomerToSkills(sessionId, customerId) {
  return await fetchJSON(p`/ajax/customers/${customerId}/${sessionId}/check_publishable_to_skills`, { method: "POST" })
    .then((json) => {
      return json;
    })
    .catch((err) => {
      return { error: err.data };
    });
}

async function startSessionCustomerPublicationToSkills(sessionId, customerId) {
  const { async_job_hash: asyncJobHash } = await fetchJSON(p`/ajax/customers/${customerId}/${sessionId}/publish_to_skills_async`, {
    method: "POST",
  });
  return asyncJobHash;
}
